// src/components/About.jsx
import React from 'react';

export default function About() {
  return (
    <div>
      <p>
        I’m <strong>Nikhil Goyal</strong>, an <strong>AI researcher and developer</strong> pursuing my undergraduate degree in <strong>Artificial Intelligence</strong> at <strong>IIT Gandhinagar</strong>. My work spans <strong>machine learning</strong>, <strong>computer vision</strong>, <strong>natural language processing</strong>, <strong>OCR</strong>, and <strong>healthcare AI</strong>, and I’ve recently built experience through my <strong>Samsung Research Internship</strong> in on-device AI and model optimization.
      </p>
      
      <p>
        Outside of work, I'm a huge fan of ambient and indie music. I also love getting lost in a good book; recently I've been into philosophical fiction, reading the works of Franz Kafka and Dostoevsky. There's just something about a well-written story or a thought-provoking non-fiction that is difficult to put in words. And hey, if you're ever in <strong>Surat</strong>, feel free to hit me up and if you're in the mood to explore the city, I'd love to show you around!
      </p>
    </div>
  );
}
